type BasketContactPayload = {
  basket_id: string
  name: string
  telephone: string
}


export class AddBasketContactRequest {
  endpointUrl: URL
  data: BasketContactPayload
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }

  constructor(endpoint: string, basketId: string, name: string, telephone: string) {
    this.endpointUrl = new URL(endpoint + 'AddBasketContact/', window.location.href)
    this.data = {
      basket_id: basketId,
      name: name,
      telephone: telephone,
    }
  }
}


export class GetBasketContactRequest {
  endpointUrl: URL
  data: { basket_id: string }
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }

  constructor(endpoint: string, basketId: string) {
    this.endpointUrl = new URL(endpoint + 'GetBasketContact/', window.location.href)
    this.data = { basket_id: basketId }
  }
}
